export const data = {
    experience: [
        {
            title: "Campus Embassador",
            subTitle: "IIT Bombay Ecell, India",
            description: "Event Management, Task Completion, Team Work, Problem-solving, Collaboration"
        },
        {
            title: "EliteCare Developer",
            subTitle: "SIH - India",
            description: "Developed 'EliteCare' healthcare website using Node.js, React, and Tailwind. Features include NGO networking, community support, and AI-driven health analysis."
        }
    ],
    education: [
        {
            title: "Lovely Professional University",
            subTitle: "Bachelor's in Computer Science - Punjab, India",
            description: "2021 - Present | Relevant coursework includes Data Structures, Algorithms, and Software Engineering."
        }
    ],
    projects: [
        
        {
            title: "EliteCare",
            subTitle: "Node.js, React, Tailwind CSS",
            description: "A platform for healthcare support, with features for NGO collaboration, community support, and AI-based health analysis.",
            date: "2024"
        },
        {
            title: "HUMAN",
            subTitle: "React, Design, UI/UX, AI",
            description: "A Self Development Website which is give personalized recommendations for growth in academics, finance, mental well-being, health. Improved interafec to 13% using AI integration",
            date: "2023"
        },
        {
            title: "Gmail Clone",
            subTitle: "React, CSS, AI Recommendations",
            description: "A Gmail Clone with 15% more efficiency and new features integrated with AI",
            date:"2024"
        }
    ],
    achievements: [
        {
            title: "Smart India Hackathon 2024 Semi Finalist",
            description: "Presented 'EliteCare' at a national-level hackathon, earning industry recognition."
        },
        {
            title: "100 Days Badge 2024 - LeetCode",
            description: "Awarded to the top 4.2% of LeetCoders for 100+ days of problem-solving in 2024."
        }

    ],
    skills: [
        { name: "JavaScript", level: "Advanced" },
        { name: "React", level: "Advanced" },
        { name: "Java", level: "Intermediate" },
        { name: "Python", level: "Intermediate" },
        { name: "SQL", level: "Intermediate" },
        { name: "HTML/CSS", level: "Advanced" },
        { name: "Node.js", level: "Intermediate" }
    ]
};
